// extracted by mini-css-extract-plugin
module.exports = {"profile":"ProfileCard_profile__2fmSx","profile_card":"ProfileCard_profile_card__xNNm8"};